import {
  _sharedReducerParagraphs,
  _sharedStateParagraphs
} from "@/shared/store/paragraphs/reducer";
import {systemActionsConstants} from "@/store/actions/system.actions";

export const initialState = _sharedStateParagraphs;

const paragraphsReducer = (state = initialState, action) => {
  switch (action.type) {
    case systemActionsConstants.SET_IS_LOGIN: {
      if (action.data === true) {
        return state;
      }
      return initialState;
    }
    default:
      return _sharedReducerParagraphs(state, action);
  }
};

export default paragraphsReducer;
